export { default as EventManager } from './event-manager';
//# sourceMappingURL=index.js.map